/**
 * G13：读取登录会话下发的"模块 → 已授予动作"并集，用于按钮/筛选项显隐。
 *
 * 数据来源：每次进入系统时 Home.vue 调 login/menus，后端把该账号所有角色的
 * rights 按模块合并（键为小写模块码）存入 sessionStorage.grantedActions；
 * 直通账号（level<=1）后端下发 null，视为全部可用。
 *
 * 语义边界（重要）：这只管界面显隐，真正的拦截永远在后端 need() 闸门与
 * 数据范围守卫——本函数返回 false 只是"少展示一个点了必被拒的按钮"。
 */

/**
 * 判断当前账号在某模块上是否被授予某动作
 * @param {String} moduleCode 模块码（大小写不敏感，后端下发键为小写）
 * @param {String} action 动作名，如 '修改'
 * @return {Boolean} true=显示该功能的入口
 */
export function hasAction (moduleCode, action) {
  const raw = window.sessionStorage.getItem('grantedActions')
  // 直通账号：后端显式下发 null
  if (raw === 'null') return true
  // 尚未下发（极端时序）时不展示——界面宁缺勿滥，后端才是真闸门
  if (!raw) return false
  try {
    const granted = JSON.parse(raw) || {}
    return (granted[String(moduleCode).toLowerCase()] || []).includes(action)
  } catch (e) {
    return false
  }
}

/**
 * 解析 sessionStorage 里的 level。
 * 缺失/非法一律按普通用户（99）——绝不把缺失当超管；同时不能写 `||99` 的偷懒式：
 * level=0 的真超管会被 0 的 falsy 误降级（2026-10-27 审查抓到过）。
 * @return {Number} level 数值
 */
export function readLevel () {
  const parsed = parseInt(window.sessionStorage.getItem('level'))
  return Number.isFinite(parsed) ? parsed : 99
}
